module.exports = __webpack_public_path__ + "static/media/queenofbradgate_1.98bf6410.jpg";